export const ROUTES = {
  HOME: '/',
  ABOUT: '/about',
  LOGIN: '/login',
};
